import { useQuery } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { formsService } from '../api/forms.service';
import { FORM_KEYS } from './queryKeys';

export function useForm(formId: string) {
  const orgId = useOrganizationStore((s) => s.activeOrganizationId);

  const { data, isLoading, isError } = useQuery({
    queryKey: FORM_KEYS.detail(orgId ?? '', formId),
    queryFn: ({ signal }) => formsService.getById(formId, signal),
    staleTime: 120_000,
    enabled: !!orgId && !!formId,
  });

  return {
    form: data?.data,
    isLoading,
    isError,
  };
}
